import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RoleAssignmentModel } from "../models/role-assignments";
import { RoleModel } from "../models/role";
import { UserModel } from "../models/user";
import { Observable } from "rxjs";
import { AppServiceHelperService } from "../../../services/app-service-helper.service";

/**
 * Injectable
 */
@Injectable({
  providedIn: 'root'
})
export class RoleManagementService {
  /**
   * Resource for roles.
   */
  private _roleResource: string;

  /**
 * Constructor
 * @param ais
 * @param httpClient
 */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    this._roleResource = this.appServiceHelper.getServiceEndpoint('pollux.settings.api', 'user');
  }

  //#region API

  /**
 * Retrieves a list of role assignments models.
 */
  getRoleAssignments(): Observable<RoleAssignmentModel[]> {
    return this.httpClient.get<RoleAssignmentModel[]>(`${this._roleResource}/managementroles/roleAssignments`);
  }

  /**
* Retrieves a list of role models.
*/
  getRoleDetails(): Observable<RoleModel[]> {
    return this.httpClient.get<RoleModel[]>(`${this._roleResource}/managementroles/details`);
  }

  /**
* Retrieves a list of users.
*/
  getUsers(): Observable<UserModel[]> {
    return this.httpClient.get<UserModel[]>(`${this._roleResource}`);
  }

  /**
* Delete assignment
*/
  deleteAssignment(oid: number): Observable<any> {
    return this.httpClient.post(`${this._roleResource}/managementroles/roleAssignments/delete`, { oid: oid });
  }

  /**
*Add new assignment
*/
  addAssignment(roleId: number, userId: number): Observable<any> {
    return this.httpClient.post(`${this._roleResource}/managementroles/roleAssignments/add`, { roleId: roleId, userId: userId });
  }
}
